import { diagnosticsCss } from "@damga/ds";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { appCss } from "./styles";
import { registerServiceWorker } from "./sw-register";

/* The artboard's register is the whole stylesheet now. The design system's
 * consumer register (the plum one) and its base tokens are no longer loaded:
 * this surface moved to the light register on 2026-09-17, and two sets of
 * `:root` tokens fighting over order is the drift this repo keeps finding.
 * Diagnostics stays, outside production only, and reads the same names. */
const style = document.createElement("style");
style.textContent = appCss + diagnosticsCss;
document.head.append(style);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

registerServiceWorker();
